import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Row,
  Col,
  InputGroup,
  ButtonGroup,
  Label,
  FormGroup,
  Modal,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../../Components/CustomTable/CustomTable";

// import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import DetailOrgDbModal from "./DetailOrgDbModal";


// import "./SwitchModal.css";

const TenantOrganization = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [detailData, setDetailData] = useState({});
  const [isEdit, setIsEdit] = useState(false)

  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [createDbModalOpen, setCreateDbModalOpen] = useState(false)
  const [selectedOrgName, SetSelectedOrgName] = useState('')
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     pageSize: 10,
//     totalPages: 0,
//     totalData: 0,
//   });



  // Fetch organizations with pagination
  const fetchOrganizations = async () => {
    setLoading(true);
    console.log('here')
    try {
      const response = await OrganizationService.GetOrgDatabaseList();

      if (response && response.data) {
        setData(response.data);
      
      } else {
        console.error("Unexpected response structure:", response);
        setData([]);
      }
    } catch (error) {
      toast.error("Error fetching organizations");
      console.error("Error fetching organizations:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

    const fetchDetail = async (id) => {
    // setLoading(true);
    console.log('here')
    try {
      const response = await OrganizationService.GetOrgDatabaseDetail(id);

      if (response && response.data) {
        setDetailData(response.data);
        setModalOpen(true)
      
      } else {
        console.error("Unexpected response structure:", response);
        setDetailData({});
      }
    } catch (error) {
      toast.error("Error fetching organizations");
      console.error("Error fetching organizations:", error);
      setDetailData({});
    } finally {
    //   setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

 
  const toggleModal = ()=> setModalOpen(prev=> !prev)


  // Handle page change
//   const handlePageChange = (page) => {
//     fetchOrganizations(page, pagination.pageSize);
//   };

//   // Handle rows per page change
//   const handlePerRowsChange = async (newPageSize, page) => {
//     fetchOrganizations(page, newPageSize);
//   };

  // Checkbox selection handler
 

  // console.log(selectedOrganizations)

  // Set organizations as paid


 

 

  // Delete organization
//   const handleDelete = async () => {
//     if (selectedDeleteItem) {
//       try {
//         await OrganizationService.delete(selectedDeleteItem.id);
//         toast.success("Organization deleted successfully");
//         fetchOrganizations(pagination.currentPage, pagination.pageSize);
//       } catch (error) {
//         toast.error("Failed to delete the record");
//       } finally {
//         setDeleteModal(false);
//         setSelectedDeleteItem(null);
//       }
//     }
//   };

const handleDetail = (id)=>{
    fetchDetail(id)
}

const handleEdit = (id)=>{
    setIsEdit(true)
    fetchDetail(id)
}



  const columns = [
   
    {
      name: "S.N",
    //   selector: (row, index) =>
    //     (pagination.currentPage - 1) * pagination.pageSize + index + 1,
        selector: (row,index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => (
        <div>
          {/* <Link to={`/api/tenant/${row.id}`}>{row?.orgNanme}</Link> */}
          <Link onClick={()=>handleDetail(row.id)}>{row?.orgNanme}</Link>

        </div>
      ),
      sortable: true,
    },
    {
      name: "Host",
      selector: (row) => row?.hostName || "N/A",
      sortable: true,
    },
    {
      name: "Server",
      selector: (row) => `${row?.server}` || "N/A",
      sortable: true,
    },
    {
      name: "dbName",
      selector: (row) => `${row?.dbName}` || "N/A",
      sortable: true,
    },
    {
      name: "dbUser",
      selector: (row) => `${row?.dbUser}` || "N/A",
      sortable: true,
    },
    {
      name: "adminEmail",
      selector: (row) => `${row?.adminEmail}` || "N/A",
      sortable: true,
    },
    {
      name: "createdDate",
      selector: (row) => `${row?.createdDate.split('T')[0]}` || "N/A",
      sortable: true,
    },
   
   
 
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleEdit(row.id)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          {/* <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => {
              setSelectedDeleteItem(row);
              setDeleteModal(true);
            }}
          >
            <i className="bx bx-trash"></i>
          </Button> */}
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Organization Management List"
          pageTitle="Organization Management"
        />
      </div>
      

      <CustomDataTable
        responsive
        striped
        // pagination
        // paginationServer
        // paginationTotalRows={pagination.totalData}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        // onChangeRowsPerPage={handlePerRowsChange}
        // onChangePage={handlePageChange}
        fixedHeader
        persistTableHead
        progressPending={loading}
        columns={columns}
        data={data}
        customStyles={{
          headCells: { style: { fontSize: "0.93rem", fontWeight: 610 } },
          rows: { style: { fontSize: "0.9rem" } },
        }}
        progressComponent={
          <div className="my-3 text-center">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
      />

     
{/* 
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
        selectedItem={selectedDeleteItem}
      /> */}

      <DetailOrgDbModal 
      isOpen={modalOpen}
      toggleModal={toggleModal}
      detailData={detailData}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
      />

   
    </div>
  );
};

export default TenantOrganization;
